import React, { FC } from "react";
import View from "../components/View";

const Prospect: FC = () => {
  return (
    <View>
      <div className="flex w-full h-full bg-neutral-800">Prospect</div>
    </View>
  );
};

export default Prospect;
